import "babel-polyfill";
import {binder} from "./libs/binder";
import "./libs/select2.full";
import {
    staticFunctions,
    headerFunction,
    contentScrollDown,
    footerNav
} from "./modules/module";
import {functionsForWordPress} from "./modules/functionsForWordPress";
import {locations} from "./modules/locations";
import {mainSection} from "./modules/mainSection";
import {helpSection} from "./modules/helpSection";
import {aboutSection} from "./modules/aboutSection";
import {customSelect} from "./modules/customSelect";
import {servicesSection} from "./modules/servicesSection";
import {scrollToService} from "./modules/scrollToService";

binder({
    bounds: {
        "body": [staticFunctions.addDevicesClasses(), functionsForWordPress],
        ".header": headerFunction,
        ".footer-nav": footerNav,
        "select.form-control": [customSelect],
        ".form-control": [staticFunctions.formItem()],
        ".page-heading": contentScrollDown,
        ".locations": locations,
        ".main-section": mainSection,
        ".help-section": helpSection,
        ".about-section": aboutSection,
        ".services-section": servicesSection,
        ".services-block": scrollToService
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js